import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import storeApi from "../storeApi";
import { AppContext } from "../../context";

const DealerShareEntry = () => {
  const navigate = useNavigate();
  const { code } = useParams();
  const location = useLocation();
  const { setCurrentUser, setDealerReferral } = useContext(AppContext);

  useEffect(() => {
    let cancelled = false;

    const resolveDealerLink = async () => {
      if (!code) {
        navigate("/products", { replace: true });
        return;
      }

      try {
        const qp = new URLSearchParams(location.search || "");
        const mobile = qp.get("mobile")?.trim();
        const referralResponse = await storeApi.dealerLinksAPI.resolveCode(
          code,
          mobile ? { mobile } : {}
        );
        const dealer = referralResponse?.dealer;
        const referralCode = dealer?.code || code;
        window.localStorage.setItem("storeReferralCode", String(referralCode));
        // Banner must not depend only on session: cross-origin cookies may not be on the next
        // request yet; the link response already includes the dealer payload.
        if (dealer && typeof setDealerReferral === "function") {
          setDealerReferral({ dealer });
        }
        const session = await storeApi.sessionAPI.getCurrentSession();
        const sessionUser =
          session?.user || session?.data?.user || null;
        const sessionDealerReferral =
          session?.dealer_referral || session?.data?.dealer_referral || null;
        if (typeof setCurrentUser === "function") {
          setCurrentUser(sessionUser);
        }
        if (typeof setDealerReferral === "function" && sessionDealerReferral) {
          setDealerReferral(sessionDealerReferral);
        }
      } catch (_error) {
        // Invalid dealer links gracefully fall back to products.
      } finally {
        if (!cancelled) navigate("/products", { replace: true });
      }
    };

    void resolveDealerLink();

    return () => {
      cancelled = true;
    };
  }, [code, location.search, navigate, setCurrentUser, setDealerReferral]);

  return null;
};

export default DealerShareEntry;
